import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PageImage(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg width={width || 78} height={height || 99} viewBox="0 0 78 99">
      <g transform="translate(-921 -365)">
        <g
          data-name="Rectangle 1763"
          transform="translate(921 381)"
          fill="rgba(251,151,46,0.3)"
          stroke="#fb972e"
          strokeWidth={4}
        >
          <rect width={63} height={83} rx={4} stroke="none" />
          <rect x={2} y={2} width={59} height={79} rx={2} fill="none" />
        </g>
        <g data-name="Path 10047" fill="#fff">
          <path
            d="M59 81H4c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h37.386L61 22.088V79c0 1.103-.897 2-2 2z"
            transform="translate(936 365)"
          />
          <path
            d="M4 4v75h55V22.903L40.544 4H4m0-4h38.229L63 21.274V79a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z"
            fill="#fb972e"
            transform="translate(936 365)"
          />
        </g>
        <rect
          data-name="Rectangle 1764"
          width={40}
          height={4}
          rx={2}
          transform="translate(948 397)"
          fill="#fb972e"
        />
        <rect
          data-name="Rectangle 1767"
          width={40}
          height={4}
          rx={2}
          transform="translate(948 419)"
          fill="#fb972e"
          opacity={0.5}
        />
        <rect
          data-name="Rectangle 1765"
          width={40}
          height={4}
          rx={2}
          transform="translate(948 408)"
          fill="#fb972e"
          opacity={0.5}
        />
        <rect
          data-name="Rectangle 1766"
          width={40}
          height={4}
          rx={2}
          transform="translate(948 430)"
          fill="#fb972e"
          opacity={0.5}
        />
        <path
          data-name="Path 10048"
          d="M976.77 367.154v19.984h19.785"
          fill="none"
          stroke="#fb972e"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={4}
        />
      </g>
    </svg>
  );
}
